<template>
  <div class="shipping-status-history">
    <p v-if="shipping.current_tracking">
      <span v-translate="{lastTrackingDate: moment.utc(shipping.current_tracking.created_at).tz($tz).format('L LT')}">
        Last tracking for this shipping sent on: %{lastTrackingDate}
      </span>
    </p>
    <ul class="p-0">
      <li class="row">
        <b-col cols="7">
          <dl>
            <dt v-translate>Status</dt>
          </dl>
        </b-col>
        <b-col cols="5">
        <dl>
          <dt v-translate>Elapsed Time</dt>
        </dl>
        </b-col>
      </li>
      <li v-for="(status, index) in shipping.status_history" :key="status.status + index" class="row" :class="status.status.toLowerCase()">
        <b-col cols="7" :class="(status.status === 'DELIVERED') ? 'text-success' : (status.status === 'INCIDENCE' ? 'text-warning' : (status.status === 'CANCELED' || status.status === 'RETURNED' ? 'text-danger' : ''))">
          <dl>
            <dd>{{shipping.status_history.length - index}}. {{ status.status }} <small>({{moment.utc(status.created_at).tz($tz).format('L LT')}})</small></dd>
            <dt v-if="status.details && status.details.reason">
              <small v-if="status.details && status.details.reason" class="d-block">
                <translate>Details:</translate>
                <span class="bg-warning text-dark d-inline-block px-1">{{status.details.reason}}</span>
                <span class="d-inline-block">
                  <span :id="'tooltip-status-details-picture-' + index" class="text-primary" style="cursor: pointer" v-if="status.details.picture || status.details.shippingPhoto">
                    <font-awesome-icon :icon="['far', 'image']" size="2x" style="font-size: 1.1rem" />
                  </span>
                  <b-tooltip :target="'tooltip-status-details-picture-' + index" triggers="hover" v-if="status.details.picture || status.details.shippingPhoto">
                    <div class="d-flex flex-column align-items-center justify-content-center" style="width: 150px; height: 200px;">
                      <img :src="status.details.picture || status.details.shippingPhoto.url" style="width: auto; height: auto; max-width: 150px; max-height: 150px;" alt="Pic" />
                      <b-button size="sm" block class="mt-1" variant="primary" :href="status.details.picture || status.details.shippingPhoto.url" target="_blank">
                        <font-awesome-icon icon="external-link-alt" size="1x" />
                      </b-button>
                    </div>
                  </b-tooltip>
                  <span :id="'tooltip-status-courier-position-' + index" class="text-danger" style="cursor: pointer" v-b-modal.modalCourierPosition @click="courierPosition = status.details.courierPosition" v-if="status.details.courierPosition">
                    <font-awesome-icon icon="map-marker-alt" size="2x" style="font-size: 1.1rem" />
                  </span>
                  <span class="text-dark" style="cursor: pointer" v-b-tooltip.hover :title="$options.filters.brize(status.meta || '-')" v-if="status.meta && (typeof status.meta === 'string' || status.meta instanceof String)">
                    <font-awesome-icon icon="comment" size="2x" style="font-size: 1.1rem" />
                  </span>
                </span>
              </small>
            </dt>
            <span>
              <font-awesome-icon :icon="status.user_id && statusUsers.findIndex(x => x.id === status.user_id) !== -1 ? 'user' : 'keyboard'" />
              <strong>{{ status.user_id && statusUsers.findIndex(x => x.id === status.user_id) !== -1 ? statusUsers.find(x => x.id === status.user_id).name : $gettext('System') }}</strong>
            </span>
          </dl>
        </b-col>
        <b-col cols="5">
          <dl v-if="!isReversible || index !== 0">
            <dd>{{elapsedTime(shipping.status_history[index].created_at, (index === 0 ? moment.utc().format('YYYY-MM-DD HH:mm:ss') : shipping.status_history[index - 1].created_at))}}</dd>
          </dl>
          <b-button size="sm" v-else variant="danger" :disabled="!isReversible" @click.prevent="revertStatus(status.id)" v-translate>
            Revert to prev.
          </b-button>
        </b-col>
      </li>
    </ul>
    <b-modal size="xl" id="modalCourierPosition" ref="modalCourierPosition" hide-header hide-footer>
      <leaflet-map ref="fullMap" style="height:80vh; position:relative;" :zoom="14" fit-once :geolocate="false" @ready="initMap" />
    </b-modal>
  </div>
</template>

<script>
import LeafletMap from '@/components/LeafletMap'

export default {
  name: 'ShippingStatusHistory',
  components: {
    LeafletMap
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      statusUsers: [],
      currentPicture: null,
      courierPosition: {}
    }
  },
  computed: {
    isReversible() {
      return (this.isSuperAdmin || this.isOperator || this.isOperatorSupervisor) &&
        this.statusReversible.indexOf(this.shipping.status_history[0].status) !== -1
    }
  },
  watch: {
    shipping: {
      handler(val) {
        this.fetchStatusUsers()
      },
      deep: true
    }
  },
  created() {
    this.fetchStatusUsers()
  },
  methods: {
    fetchStatusUsers() {
      let userIds = []
      for (let i = 0; i < this.shipping.status_history.length; i++) {
        if (this.shipping.status_history[i].user_id) {
          userIds.push(this.shipping.status_history[i].user_id)
        }
      }
      if (userIds.length > 0) {
        let params = {
          page: 0,
          limit: 100,
          filter_groups: [
            {
              filters: [['id', 'in', [...new Set(userIds)]]]
            }
          ]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'users', {params: params})
          .then(response => {
            this.statusUsers = response.body.data
          })
      }
    },
    initMap() {
      if (this.courierPosition) {
        let markers = [{
          id: 1000,
          lat: this.courierPosition.lat,
          lng: this.courierPosition.lng,
          icon: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png',
          x: 10,
          y: 10,
          infoText: 'Courier',
          tooltip: true
        }]
        setTimeout(() => {
          this.$refs.fullMap.addMarkers(markers)
        }, 1000)
      }
    },
    revertStatus(id) {
      if (
        confirm('Are you sure you want to REVERT this last status to the previous one?\n\nWARNING: THIS ACTION CANNOT BE UNDONE!')
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'status/' + id)
          .then(response => {
            this.$emit('updated', this.shipping)
          })
      }
    }
  }
}
</script>
